
import React, { useState, useEffect, useRef } from "react";
import "bootstrap-icons/font/bootstrap-icons.css";
import Sidebar from "./Sidebar";
import Swal from "sweetalert2";
import JoditEditor from "jodit-react";
import axios from "axios";
import { getBlogs, createBlog, updateBlog, deleteBlog } from "../api/auth/blogService";
import { getAllCategories } from '../api/auth/categoryService';


function Blogupdate() {
  const [values, setValues] = useState({
    image: null,
    name: "",
    title: "",
    description: "",
    category_id: "",
  });
  const [editId, setEditId] = useState(null);
  const [blogData, setBlogData] = useState([]);
  const [categories, setCategories] = useState([]);
  const editor = useRef(null);
  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const categoriesData = await getAllCategories();
      setCategories(categoriesData);
    } catch (error) {
      console.error('Error fetching categories:', error);
      Swal.fire('Error!', 'Failed to fetch categories.', 'error');
    }
  };
  // Fetch blog categories
  const getCategories = async () => {
    const response = await axios.getPlanTypes("/category", {
      headers: { authType: "PreLogin" },
    });
    return response.data;
  };

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const data = await getCategories();
        setCategories(data);
      } catch (error) {
        console.error("Error fetching categories:", error);
        Swal.fire("Error", "Failed to fetch blog categories.", "error");
      }
    };
    fetchCategories();
  }, []);

  // Fetch blogs on mount

  useEffect(() => {
    const fetchBlogData = async () => {
      try {
        const data = await getBlogs();
        setBlogData(data);
      } catch (error) {

        console.error("Error fetching blog data:", error);
        Swal.fire("Error", "Failed to fetch blog data.", "error");

      }
    };
    fetchBlogData();
  }, []);

  // Handle input change
  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "image") {

      setValues((prev) => ({ ...prev, image: files[0] }));
    } else {
      setValues((prev) => ({ ...prev, [name]: value }));
    }
  };

  // Submit form
  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();

    const currentDate = new Date().toISOString().split("T")[0];

    formData.append("image", values.image);
    formData.append("name", values.name);
    formData.append("title", values.title);
    formData.append("description", values.description);
    formData.append("date", currentDate);
    formData.append("category_id", values.category_id);

    try {
      if (editId !== null) {
        // Update blog

        const response = await updateBlog(editId, formData);
        const updatedData = blogData.map((blog) =>
          blog.id === editId ? response : blog
        );
        setBlogData(updatedData);

        Swal.fire("Success!", "Blog updated successfully!", "success");

        setEditId(null);
      } else {
        // Create new blog
        const response = await createBlog(formData);
        setBlogData([...blogData, response]);

        Swal.fire("Success!", "Blog added successfully!", "success");
      }

      // Reset form
      setValues({ image: null, name: "", title: "", description: "", category_id: "" });
    } catch (error) {
      console.error("Error submitting blog:", error);
      Swal.fire("Error", "Failed to submit blog item.", "error");

    }
  };

  // Set form values for editing
  const handleEdit = (item) => {
    setValues({
      image: null, // must re-upload
      name: item.name,
      title: item.title,
      description: item.description,

      category_id: item.category_id || "",

    });
    setEditId(item.id);
  };


  // Delete blog
  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This will permanently delete the blog entry.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",

    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await deleteBlog(id);
          setBlogData(blogData.filter((item) => item.id !== id));

          Swal.fire("Deleted!", "The blog has been deleted.", "success");
        } catch (error) {
          console.error("Delete error:", error);
          Swal.fire("Error", "Failed to delete blog item.", "error");

        }
      }
    });
  };

  return (
    <div>
      <Sidebar />

      {/* Form Section */}

      <div className="col-md-9 px-0" style={{ marginLeft: "210px" }}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <h5 className="page-title">Blog Update</h5>
            </div>
          </div>

          <div className="row">
            <div className="col-12 mb-3">
              <form onSubmit={handleSubmit}>
                <div className="row align-items-end">

                  {/* Image Upload */}

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Blog Image</label>
                    <input
                      type="file"
                      className="form-control"
                      accept="image/*"
                      name="image"
                      onChange={handleChange}
                      required={!editId}
                    />
                  </div>


                  <div className="col-md-6 mb-4">
                    <label className="form-label">Title</label>
                    <input
                      type="text"
                      className="form-control"
                      name="title"
                      placeholder="Enter Title"
                      value={values.title}
                      onChange={handleChange}
                      required
                    />
                  </div>


                  {/* Name */}

                  <div className="col-md-6 mb-4">
                    <label className="form-label">Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      placeholder="Enter Name"
                      value={values.name}
                      onChange={handleChange}
                      required
                    />
                  </div>



                  {/* Category */}
                  <div className="col-md-6 mb-4">
                    <label className="form-label">Blog Category</label>
                    <select
                      className="form-select"
                      name="category_id"
                      value={values.category_id}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Blog Category</option>
                      {categories.map((type) => (
                        <option key={type.id} value={type.id}>
                          {type.category}
                        </option>
                      ))}
                    </select>

                  </div>
                </div>
                {/* Description */}
                <div className="row mb-4">

                  <div className="col-md-12 mb-6">
                    <label className="form-label">Description</label>
                    <JoditEditor
                      ref={editor}
                      value={values.description}
                      tabIndex={1}

                      onBlur={(newContent) =>
                        handleChange({
                          target: { name: "description", value: newContent },
                        })
                      }

                    />
                  </div>
                </div>


                {/* Submit */}
                <button type="submit" className="btn btn-primary">
                  {editId !== null ? "Update Blog" : "Add Blog"}

                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Table Section */}
      <div className="col-md-10">
        <table className="table table-bordered" style={{ marginLeft: "210px" }}>

          <thead>
            <tr>
              <th>#</th>
              <th>Blog Image</th>
              <th>Title</th>
              <th>Name</th>
              <th>Description</th>
              <th>Date</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {blogData.length > 0 ? (
              blogData.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td>
                    <img
                      src={
                        item.imageBytes
                          ? `data:image/jpeg;base64,${item.imageBytes}`

                          : "https://via.placeholder.com/100"
                      }
                      alt={item.name}
                      style={{ width: "100px", height: "100px" }}

                    />
                  </td>
                  <td>{item.title}</td>
                  <td>{item.name}</td>
                  <td>{item.description}</td>
                  <td style={{width:'10%'}}>{item.date}</td>
                  <td style={{width:'12%'}}>

                    <button
                      className="btn btn-primary me-2"
                      onClick={() => handleEdit(item)}
                    >
                      Edit
                    </button>
                    <button
                      className="btn btn-danger"
                      onClick={() => handleDelete(item.id)}
                    >

                      Delete
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center">
                  No blog entries found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}


export default Blogupdate;

